module.exports = __webpack_public_path__ + "static/media/tallscotcheggs.0bb7f98f.png";